import { render, staticRenderFns } from "./form-produto-estoque.vue?vue&type=template&id=22b729d4&scoped=true&"
import script from "./form-produto-estoque.vue?vue&type=script&lang=js&"
export * from "./form-produto-estoque.vue?vue&type=script&lang=js&"
import style0 from "./form-produto-estoque.vue?vue&type=style&index=0&id=22b729d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b729d4",
  null
  
)

export default component.exports